const crabRouter = [
    {
        path: "list-crab",
        name: "crab",
        component: () => import("@/views/admin/crab"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-crab/add",
        name: "addCrab",
        component: () => import("@/views/admin/crab/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
    {
        path: "list-crab/edit/:id",
        name: "editCrab",
        component: () => import("@/views/admin/crab/function"),
        default: true,
        meta: {
            model: "kind",
            // requiresAuth: true,
        },
    },
];
export default crabRouter;